const _import = require('../import-' + process.env.NODE_ENV)

const containerRouter = [
  {
    path: '/container/index',
    name: 'containerIndex',
    component: _import('container/index'),
    meta: {
      title: '容器盘点',
      auth: true
    }
  }
]
export default containerRouter



// WEBPACK FOOTER //
// ./src/router/work/container.js